export default __webpack_public_path__ + "static/media/bank.348c1635.svg";